import { Factory } from 'miragejs';
import faker from 'faker';

export default {
  user: Factory.extend({
    name: () => faker.name.findName(),
  }),
};
